export * from './auth';
export * from './regex';
export * from './options';
export * from './status';

export const MAX_BOX_QUANTITY = 300;
export const POST_CODE_API = process.env.VUE_APP_POST_CODE_API_URL;
